import { render, staticRenderFns } from "./NovoCargoAssociado.vue?vue&type=template&id=3093adcb"
import script from "./NovoCargoAssociado.vue?vue&type=script&lang=ts"
export * from "./NovoCargoAssociado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports